import { render, staticRenderFns } from "./WaiverInsights.vue?vue&type=template&id=20365aba&scoped=true&"
import script from "./WaiverInsights.vue?vue&type=script&lang=js&"
export * from "./WaiverInsights.vue?vue&type=script&lang=js&"
import style0 from "./WaiverInsights.vue?vue&type=style&index=0&id=20365aba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20365aba",
  null
  
)

export default component.exports